"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var Episode_less_1 = __importDefault(require("./Episode.less"));
var renderPlaceholder = function () { return (react_1.default.createElement(react_2.default, { className: Episode_less_1.default['placeholder'], name: 'symbol' })); };
var Episode = function (_a) {
    var _b;
    var name = _a.name, title = _a.title, season = _a.season, episode = _a.episode, poster = _a.poster, background = _a.background, thumbnail = _a.thumbnail, deepLinks = _a.deepLinks, hideSpoilers = _a.hideSpoilers, onClick = _a.onClick;
    var onEpisodeClick = (0, react_1.useCallback)(function (event) {
        onClick && onClick(event, deepLinks.metaDetailsStreams);
    }, [onClick, deepLinks.metaDetailsStreams]);
    var renderPoster = (0, react_1.useCallback)(function () { return (react_1.default.createElement(components_1.Image, { className: Episode_less_1.default['artwork'], src: poster, alt: ' ', renderFallback: renderPlaceholder })); }, [poster]);
    var renderBackground = (0, react_1.useCallback)(function () { return (react_1.default.createElement(components_1.Image, { className: Episode_less_1.default['artwork'], src: background, alt: ' ', renderFallback: renderPoster })); }, [background, renderPoster]);
    return (react_1.default.createElement(components_1.Button, { className: Episode_less_1.default['episode'], href: deepLinks.metaDetailsStreams, onClick: onEpisodeClick },
        react_1.default.createElement("div", { className: Episode_less_1.default['artwork-container'] },
            react_1.default.createElement(components_1.Image, { className: (0, classnames_1.default)(Episode_less_1.default['artwork'], (_b = {}, _b[Episode_less_1.default['blurred']] = hideSpoilers, _b)), src: thumbnail, alt: ' ', renderFallback: renderBackground })),
        react_1.default.createElement("div", { className: Episode_less_1.default['info'] },
            react_1.default.createElement("div", { className: Episode_less_1.default['label'] },
                "S",
                season,
                "E",
                episode),
            react_1.default.createElement("div", { className: Episode_less_1.default['name'] }, name),
            title ?
                react_1.default.createElement("div", { className: Episode_less_1.default['title'] }, title)
                :
                    null)));
};
exports.default = Episode;
